/**
 * Query key utilities for membership tiers
 */
export const membershipTiersKeys = {
  findAll: (params?: unknown) =>
    params
      ? (["membership-tiers", "findAll", params] as const)
      : (["membership-tiers", "findAll"] as const),
  findOne: (id: string) => ["membership-tiers", "findOne", id] as const,
} as const
